// extracted by mini-css-extract-plugin
module.exports = {"userButton":"MenuItem_userButton__2PklL","selected":"MenuItem_selected__1IEr-"};